module.exports = __webpack_public_path__ + "img/狐狸-素材.edd0b3ef.svg";